import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter, { WithRouterProps } from "components/Common/withRouter"

//i18n
import { withTranslation, WithTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

interface SidebarProps extends WithRouterProps, WithTranslation {
  type?: string
  theme?: string
  isMobile?: boolean
}

const Sidebar: React.FC<SidebarProps> = (props) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          <SidebarContent router={props.router} />
        </div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = (state: any) => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar))) as any
